import { jsx as _jsx } from "react/jsx-runtime";
export function Skeleton({ className = '' }) {
    return (_jsx("div", { className: `animate-pulse rounded-lg bg-[var(--bp-surface-2)] ${className}`, "aria-hidden": true }));
}
//# sourceMappingURL=skeleton.js.map